// [ai] The keyboard sheet (?): the KEYMAP + the mounted page's own keys (app/pageSeam.ts) as a definition list; the backdrop, Close or Esc (the chain) dismiss it.
import { KEYMAP } from "../core/keys";
import { pageKeys } from "../app/pageSeam";
import { usePlayer } from "../stores/player";
import { usePlayerCtl } from "./context";
export function Help() {
  const p = usePlayerCtl(); const on = usePlayer(s => s.help); if (!on) return null;
  return (
    <div className="ds-help" role="dialog" aria-label="Keyboard shortcuts" onClick={e => { if (e.target === e.currentTarget) p.showHelp(false); }}>
      <div className="ds-help-card"><h3>Keyboard</h3><dl>{[...KEYMAP, ...pageKeys()].flatMap(([k, d]) => [<dt key={k}>{k}</dt>, <dd key={k + "d"}>{d}</dd>])}</dl><button type="button" className="ds-chip" onClick={() => p.showHelp(false)}>Close</button></div>
    </div>
  );
}
